<template>
  <BaseNew
    @new-confirm-action="createEntry"
    @new-cancel-action="resetForm"
    @new-open-action="loadServerEntry"
    @clear-form-errors="clearFormErrors"
    ref="baseNew"
    width="50%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :modelNameSingular="modelNameSingular"
  >
    <template slot="newForm">
      <Form
        ref="form"
        :entry="entry"
        :extraData="extraData"
        :modelNameSingular="modelNameSingular"
      />
    </template>
    
  </BaseNew>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseNew from "@shared_components/base_new.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      entry: null,
      formErrors: [],
      extraData: null,
    };
  },
  props: {
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseNew: BaseNew
  },
  methods: {
    loadServerEntry: function() {
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_NEW_PATRIMONY_CATEGORY_QUERY,
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.entry = response.data.adminContext.patrimonyCategory;
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    createServerEntry: function(category) {
      // console.log("category", category, this.entry.validations, this.deepFilterEntryWithAllowedFieldsForMutation(category, this.entry.validations));
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: CREATE_PATRIMONY_CATEGORY_MUTATION,
          variables: {
            input: this.deepFilterEntryWithAllowedFieldsForMutation(category, this.entry.validations)
          }
        })
        .then(response => {
          var errors = response.data.createPatrimonyCategory.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseNew.closeDialog();
            this.$emit("entry-created", response.data.createPatrimonyCategory.patrimonyCategory);
          }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError){
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors){
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    createEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.createServerEntry(this.entry);
        this.resetForm();
      }
    },
    resetForm: function() {
      this.$refs.form.resetFormInputs();
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const LOAD_NEW_PATRIMONY_CATEGORY_QUERY = gql `
  {
    adminContext{
      patrimonyCategory {
        id
        name
        kind       
        validations
      }      
    }
    accountGlobalSharedContext {
      allPatrimonyCategoriesKinds
    }     
  }
`;

const CREATE_PATRIMONY_CATEGORY_MUTATION = gql `
  mutation($input: PatrimonyCategoryCreateInputObject!) {
    createPatrimonyCategory(input: $input) {
      patrimonyCategory {
        name
        kind
      }
      errors
    }
  }
`;

</script>

<style scoped></style>
